import { createFileRoute } from '@tanstack/react-router';
import { NoWorkspace } from '@features/eor/NoWorkspace';

export const Route = createFileRoute('/eor/no-workspace')({
  validateSearch: (s: Record<string, unknown>): { email: string } => ({
    email: typeof s.email === 'string' ? s.email : '',
  }),
  component: NoWorkspace,
});
